import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CCloseButton, CSpinner } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'
import { AppSidebarNav } from './AppSidebarNav'
import SidebarBrand from './SidebarBrand'
import { setSidebarShow, toggleSidebarUnfoldable } from '../store/slices/uiSlice'
import { useNavigation } from '../hooks/useNavigation'
import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.ui?.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.ui?.sidebarShow)
  const { navigation, loading } = useNavigation()

  // console.log('AppSidebar render - sidebarShow:', sidebarShow, 'unfoldable:', unfoldable, 'navigation:', navigation)

  const handleBackdropClick = () => {
    console.log('Backdrop clicked')
    dispatch(setSidebarShow(false))
  }

  const handleToggleUnfoldable = () => {
    console.log('Toggle unfoldable clicked')
    dispatch(toggleSidebarUnfoldable())
  }

  return (
    <>
      {/* Sidebar */}
      <div
        className={`sidebar-custom ${unfoldable ? 'sidebar-narrow' : ''} ${sidebarShow ? 'show' : 'hide'}`}
      >
        {/* Header */}
        <div className="sidebar-header">
          <SidebarBrand />
          <CCloseButton
            className="d-lg-none ms-auto"
            onClick={() => dispatch(setSidebarShow(false))}
          />
        </div>

        {/* Navigation */}
        <SimpleBar className="sidebar-nav-wrapper">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
              <CSpinner color="primary" />
            </div>
          ) : (
            <AppSidebarNav items={navigation} />
          )}
        </SimpleBar>
        {/* Footer */}
        <div className="sidebar-footer d-none d-lg-flex justify-content-end px-2">
          <button
            className="sidebar-toggler p-0"
            onClick={handleToggleUnfoldable}
            aria-label="Toggle sidebar"
            style={{
              background: "none",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "26px",
              height: "26px"
            }}
          >
          </button>
        </div>

      </div>

      {/* Mobile Backdrop */}
      <div
        className={`sidebar-backdrop d-lg-none ${sidebarShow ? 'show' : ''}`}
        onClick={handleBackdropClick}
      />
    </>
  )
}

export default React.memo(AppSidebar)
